import React, { forwardRef } from "react";
import { BSSpan } from "../../types";

export const DropdownItemText = forwardRef<HTMLSpanElement, BSSpan>(
  ({ children, component: Component = "span", ...props }, ref) => (
    <Component {...props} className="dropdown-item-text" ref={ref}>
      {children}
    </Component>
  )
);